// const baseSize = 32
// // 设置 rem 函数
// function setRem () {
//
//   if (document.body.clientWidth==360 && window.screen.height==760) {    // 华为荣耀10
//     // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
//     const scale = document.documentElement.clientWidth / 830
//     // 设置页面根节点字体大小
//     document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
//   } else {
//     // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
//     const scale = document.documentElement.clientWidth / 750
//     // 设置页面根节点字体大小
//     document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
//   }
//
// }
// // 初始化
// setRem()
// // 改变窗口大小时重新设置 rem
// window.onresize = function () {
//   setRem()
// }

(function(doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function() {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      var shouldRem = 16 * (clientWidth / 375);

      docEl.style.fontSize = shouldRem + 'px';

      if(window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize) {
        var size = window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize.split('p')[0];
        console.log("size======" + size)
        if(size != shouldRem) {
          var nowRem = shouldRem * (shouldRem / size);
          docEl.style.fontSize = nowRem + 'px';
        }
      }

    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);



// WEBPACK FOOTER //
// ./src/utils/rem.js